import MuiAlert from "@mui/lab/Alert";
import { Snackbar } from "@mui/material";
import { Component, RefObject } from "react";
import LoadingComponent from "../utils/LoadingComponent";
import { WithStylesProps } from "../utils/WithStyles";
import LoginForm from "../utils/login-form/LoginForm";
import { AlertSeverity } from "./_interfaces/obypay";

interface ObyPayLoginProps extends WithStylesProps {
    tokenRef: RefObject<HTMLInputElement>
    keyRef: RefObject<HTMLInputElement>
    isLoading: boolean
    showAlert: boolean
    alertSeverity: AlertSeverity
    _closeSnackBar: () => void
    message: string | undefined
    _connectService: () => any
}

class ObypayLogin extends Component<ObyPayLoginProps> {
    render() {
        const { tokenRef, keyRef, isLoading, showAlert, alertSeverity, _closeSnackBar, message, _connectService } = this.props;
        return (
            <div style={this.props.styles.rootStyle}>
                {
                    isLoading && <LoadingComponent isOpen={isLoading} />
                }
                <Snackbar
                    open={showAlert}
                    autoHideDuration={6000}
                    onClose={_closeSnackBar}
                >
                    <MuiAlert severity={alertSeverity} onClose={_closeSnackBar}>
                        {message}
                    </MuiAlert>
                </Snackbar>
            <div style={this.props.styles.formStyle}>
            <LoginForm>
                <LoginForm.Input name="token" placeholder="Token" type="text" inputRef={tokenRef} styles={{ color: this.props.styles.color, fontSize: this.props.styles.fontSize }} />
                <LoginForm.Input name="key" placeholder="Signature key" type="password" inputRef={keyRef} styles={{ color: this.props.styles.color, fontSize: this.props.styles.fontSize }} />
                <LoginForm.Submit onSubmit={_connectService}>
                    Connexion
                </LoginForm.Submit>
            </LoginForm>
            </div>
        </div>
        )
    }
}

export default ObypayLogin;